export default __webpack_public_path__ + "6497f4a5a93770014dfffdba73720de5.png";